module.exports = __webpack_public_path__ + "img/demo_1.9b194383.jpg";